<template>
	<div>
		<div class="row">
			<div class="col-xs-12 col-md-3 form-group">
				<label v-show="funcao.seq == 1"
					><span class="no-print"></span
					>{{ _traducao('global', 'funcao') }}:</label
				>
				<label v-show="funcao.seq != 1"
					><span class="no-print"></span
					>{{ _traducao('global', 'mudancaFuncao') }}:</label
				>
				<select v-model="funcao.id_funcao" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(it, idx) in funcoes" :value="it.id" :key="idx">
						{{ it.nome }}
					</option>
				</select>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label
					><span class="no-print"></span
					>{{ _traducao('global', 'fabricante') }}:</label
				>
				<select v-model="funcao.id_fabricante" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(it, idx) in fabricantes" :value="it.id" :key="idx">
						{{ it.descricao }}
					</option>
				</select>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label
					><span class="no-print"></span
					>{{ _traducao('global', 'modelo') }}:</label
				>
				<select v-model="funcao.id_modelo" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(it, idx) in modelos" :value="it.id" :key="idx">
						{{ it.descricao }}
					</option>
				</select>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<button
					class="btn btn-danger btn-xs no-print"
					type="button"
					style="position: absolute; right: 15px; top: -7px"
					@click="remover()"
					v-show="funcao.seq != 1"
				>
					<i class="fa fa-trash-o fa-fw"></i
					>{{ _traducao('global', 'remover') }}
				</button>
				<label
					><span class="no-print"></span
					>{{ _traducao('global', 'data') }}:</label
				>
				<flDateTime
					@v-model="(val) => (funcao.data = val)"
					:value="funcao.data"
					:lang="_getLangDp"
					:format="_formatDate"
					name="data"
				/>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label
					><span class="no-print"></span
					>{{ _traducao('global', 'licenca') }}:</label
				>
				<select v-model="funcao.id_licenca" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option v-for="(licenca, i) in licencas" :key="i" :value="licenca.id">
						{{ `${licenca.sigla} - ${licenca.descricao}` }}
					</option>
				</select>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label
					><span class="no-print"></span
					>{{ _traducao('global', 'numeroLicenca') }}:</label
				>
				<input
					autocomplete="off"
					type="text"
					v-model="funcao.numero_licenca"
					class="form-control input-sm"
				/>
			</div>

			<div class="col-xs-12 col-md-3 form-group">
				<label
					><span class="no-print"></span
					>{{ _traducao('global', 'habilitacao') }}:</label
				>
				<select v-model="funcao.id_habilitacao" class="form-control input-sm">
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option
						v-for="(habilitacao, i) in listarHabilitacoes"
						:key="i"
						:value="habilitacao.id"
					>
						{{ habilitacao.descricao }}
					</option>
				</select>
			</div>
		</div>

		<div class="row" v-show="!ultimaFuncao">
			<div class="col-xs-12">
				<hr />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		funcoes: {
			type: Array,
			require: true,
			default: []
		},
		fabricantes: {
			type: Array,
			require: true,
			default: []
		},
		licencas: {
			type: Array,
			require: true,
			default: []
		},
		habilitacoes: {
			type: Array,
			require: true,
			default: []
		},
		ultimaFuncao: {
			type: Boolean,
			required: true,
			default: false
		},
		funcao: {
			type: Object,
			required: true,
			default: {}
		}
	},
	data() {
		return {
			modelos: []
		}
	},
	watch: {
		'funcao.id_fabricante'(val, oldVal) {
			if (val != oldVal) {
				this.funcao.id_modelo = ''
				this.carregarModelos()
			}
		},
		'funcao.id_licenca'(val, oldVal) {
			if (val != oldVal) {
				this.funcao.id_habilitacao = ''
			}
		}
	},
	computed: {
		listarHabilitacoes() {
			if (!this.funcao.id_licenca) {
				return []
			}
			const licenca = this.licencas.find(
				(item) => item.id == this.funcao.id_licenca
			)
			return this.habilitacoes.filter(({tipo_aeronave}) => {
				return tipo_aeronave == licenca.tipo_aeronave ||
					licenca.tipo_aeronave == 'C' ||
					licenca.tipo_aeronave == 'D'
			})
		}
	},
	mounted() {
		if (this.funcao.id_modelo) {
			this.carregarModelos()
		}
	},
	methods: {
		remover() {
			window.bus.$emit('remover-funcao', this.funcao.seq)
		},
		carregarModelos() {
			if (this.funcao.id_fabricante > 0) {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._axios(
					`/Modelo/get_by_fabricante/${this.funcao.id_fabricante}`,
					'get',
					{
						callback: (retorno) => {
							if (retorno._request && retorno._status) {
								this.modelos = retorno.lista
							}
						},
						finally: () => {
							bus.$emit('load-out')
						}
					}
				)
			} else {
				this.modelos = []
			}
		}
	}
}
</script>